module.exports = __webpack_public_path__ + "img/图片3.8b0d54ab.png";